<template>
  <div>

    <div class='nav' ref="scrollTarget" @click="getMovieByClass('api/movie/read', {class: $event.target.textContent})">
      <span>动作片</span>
      <span>喜剧片</span>
      <span>爱情片</span>
      <span>动画片</span>
    </div>

    <MovieList :list=movieList :movClass=movClass @playMovie="handlePlayMovie"></MovieList>

    <el-pagination
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout=" total, prev, pager, next"
      background
      :pager-count=7  
      @current-change="handleCurrentChange"
    />


  </div>
</template>

<script>
  import {movieList} from '@/test-data/movies'

export default {
  // components: { MovItem },
  data () {
    return {
      movieList: [],
      movClass: '动作片',
      playSrc: '',

      pageSize: 20,
      currentPage: 1,
      total: 0
    }
  },
  created () {
    this.getMovieByClass('api/movie/read', {class: this.movClass})


  },
  mounted () {
    // console.log(movieList)
  },
  methods: {
    handlePlayMovie(e) {
      this.playSrc = e
      console.log('开始播放: ', this.playSrc)
    },
    getMovieByClass(apiPath, bodyObj) {
      const apiUrl = this.$base_url + apiPath
      if (!('pageSize' in bodyObj)) {
        this.currentPage = 1
        bodyObj = {...bodyObj, pageSize: this.pageSize, currentPage: this.currentPage}
      }
      console.log('post请求body: ', bodyObj)
      this.$axios.post(apiUrl, bodyObj).then(res=>{
        console.log('数据库返回: ', res)
        this.movieList = res.data.data,
        this.total = res.data.docCounts
      })
      .catch(err=>{console.error(err)})
    },
    handleCurrentChange(e) {
      console.log('点击页面: ', e)
      this.currentPage = e
      this.getMovieByClass('api/movie/read', {
        class: this.movClass,
        pageSize: this.pageSize,
        currentPage: this.currentPage
      })
      this.scrollToElement()
    },
    scrollToElement() {
      this.$nextTick(() => {
        this.$refs.scrollTarget.scrollIntoView()
      })
    }
  }
}
</script>

<style lang="less">
    .nav {
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      background: black;
      span {
        width: 25%;
        padding: 15px;
        text-align: center;
      }
    }

    .el-pagination {
//      border: 1px solid red;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      .el-pagination__total {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
</style>